<template>
  <b-card header-tag="header" class="apply-box">
    <h4>The submission of this form will the following updates</h4>
    <ol>
      <li>It finds the application of the candidate in your Greenhouse instance by using their email address and the job they applied to.</li>
      <li>Updates the referrer details on the candidate profile in your Greenhouse instance with the user you select.</li>
      <li>Imports the application ID from your Greenhouse instance to Real Links, so the referrer user will be rewarded with the relevant points and tokens.</li>
    </ol>
    <p>The job will run asynchronously and may take a few minutes to complete.</p>
    <hr />
    <advanced-form
      autocomplete="off"
      submit-label="Save Application"
      :form="formFields"
      v-bind="form"
      v-model="form"
      @submit="input()"
    />
    <b-row>
      <b-col cols="12" v-if="applied">
        <h3 class="text-center pt-3">Import started. Please wait…</h3>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import AdvancedForm from '@/components/AdvancedForm';
import { mapRoot } from '@src/mixins/root';
import gql from 'graphql-tag';

const AssignJobApplicationMutation = gql`
  mutation AssignJobApplication($input: String!) {
    assignJobApplication(input: $input)
  }
`;

export default {
  name: 'Apply-Assign-Recruiter',
  components: {
    AdvancedForm
  },
  data: () => ({
    applied: false,
    form: {},
    err: null,
    allUsers: null,
    jobSearchQuery: null,
    selectedUser: null,
    selectedJob: null,
    state: null,
  }),
  props: {
    applicationsArray: Array,
  },
  computed: {
    ...mapRoot([ 'isRecruiter' ]),
    formFields() {
      return {
        selectedJob: {
          label: 'Job',
          type: 'RELATION',
          required: true,
          options: {
            type: 'jobs',
            title: 'Jobs',
            many: false,
            order: 'CREATED_DESC',
          },
          helpText: 'Select a job',
        },
        selectedUser: {
          label: 'Referee User',
          type: 'RELATION',
          required: true,
          options: {
            type: 'users',
            title: 'User',
            many: false,
            order: 'CREATED_DESC',
          },
          helpText: 'Select the referee user',
        },
        emailAddress: {
          label: 'Email Address',
          placeholder: 'e.g. john.smith@gmail.com',
          required: true,
          type: 'STRING',
          options: {
            autocomplete: 'off',
          },
          validation: {
            isEmailAddress: true,
          },
        },
        createdAt: {
          label: 'Created At',
          placeholder: 'e.g. 2020-12-01 13:00',
          helpText: 'The date and time when the candidate applied',
          type: 'DATETIME',
        },
      };
    },
  },
  methods: {
    async input() {
      this.applied = true;

      const input = {
        referrerUserID: this.form.selectedUser.id,
        jobID: this.form.selectedJob.id,
        candidateEmail: this.form.emailAddress,
        createdAt: this.form.createdAt
      };

      try {
        const response = await this.$apollo.mutate({
          mutation: AssignJobApplicationMutation,
          variables: { input: JSON.stringify(input) },
        });

        const { data: { assignJobApplication } } = response;
        const { status, message } = assignJobApplication ? JSON.parse(assignJobApplication) : {};

        if (status === 'success') {
          this.$notification({ title: 'Import Routine Completed', message, variant: 'success' });
        } else {
          this.$notification({ title: 'An Error Occurred', message, variant: 'danger' });
        }
      } catch (error) {
        console.log(error);
        this.$notification({ title: 'An Error Occurred', message: error.message, variant: 'danger' });
      }
    },
  }
};
</script>

<style lang="scss">
  @import './../../scss/variables';

  .apply-box {
    form {
      padding: 1rem;
      width: 100%;
    }

    .btn {
      margin: 0 auto;
    }

    .btn-primary {
      margin-top: 1em;
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/jobs/applyAssign.vue